import React from 'react';
import '../../style/GearsSpinner.css';

const GearsSpinner = ({ alt = 'Loading', className = '', style }) => (
  <span
    className={`gears-spinner ${className}`.trim()}
    style={style}
    role="img"
    aria-label={alt}
  >
    <span className="gears-spinner__gear gears-spinner__gear--1" />
    <span className="gears-spinner__gear gears-spinner__gear--2" />
    <span className="gears-spinner__gear gears-spinner__gear--3" />
  </span>
);

export default GearsSpinner;
